export default __webpack_public_path__ + "static/media/read-1.c7b75ee1.svg";